module.exports = __webpack_public_path__ + "img/account-black.e9e3f105.svg";